
export const ACTIVITY_GRID_DATA = "ACTIVITY_GRID_DATA";
export const ACTIVITY_GRID_ERROR = "ACTIVITY_GRID_ERROR";
export const ACTIVITY_GRID_LOADING = "ACTIVITY_GRID_LOADING";
export const ACTIVITY_GRID_PAGE_CHANGE = "ACTIVITY_GRID_PAGE_CHANGE";
export const ACTIVITY_GRID_STATE_CHANGE = "ACTIVITY_GRID_STATE_CHANGE";